import { connect } from "react-redux";
import realAuthGoogleComplete from "../auth/AuthGoogleComplete";

import { handleGoogleLoginComplete } from "../../redux/auth/sessions/actions";

const AuthGoogleComplete = connect(
  () => ({}),
  dispatch => ({
    handleGoogleLoginComplete(navigate, code, state) {
      return dispatch(handleGoogleLoginComplete(navigate, code, state));
    }
  })
)(realAuthGoogleComplete);

export default AuthGoogleComplete;
